import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { apiCall, formattedPrice } from '../helpers/MainHelper';

const dateLabel = value => value ? new Date(value).toLocaleDateString('tr-TR') : '-';

export default function ReportOperationsTable({ filters }) {
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [retry, setRetry] = useState(0);

  useEffect(() => {
    const controller = new AbortController();
    let canceled = false;
    setLoading(true); setError(false);
    const payload = { page, per_page: perPage };
    Object.keys(filters).forEach(key => {
      if (filters[key] !== '' && filters[key] !== null) payload[key] = filters[key];
    });
    apiCall('business/reports-v2/operations', 'post', payload, { signal: controller.signal })
      .then(response => { if (!canceled) setResult(response); })
      .catch(() => { if (!canceled) setError(true); })
      .finally(() => { if (!canceled) setLoading(false); });
    return () => { canceled = true; controller.abort(); };
  }, [filters, page, perPage, retry]);

  const pagination = result?.pagination;
  const currentPage = pagination?.page || page;
  return (
    <section className="rz-panel rz-operation-register" aria-busy={loading}>
      <div className="rz-section-title">
        <div><span>SERVİS KAYITLARI</span><h3>Filtrelenen servisler</h3>
          <p>Kayıt tarihine göre tüm durumlar listelenir. Ciro ve kârlılık yalnızca tamamlanan servislerden hesaplanır.</p></div>
      </div>
      {loading ? <div className="rz-empty" role="status">Servisler yükleniyor…</div>
        : error ? <div className="rz-error" role="alert">Servis listesi alınamadı.
          <button type="button" className="rz-link-button" onClick={() => setRetry(value => value + 1)}>Tekrar dene</button></div>
        : result?.data?.length ? <div className="table-responsive"><table className="rz-table">
          <thead><tr><th>Servis</th><th>Müşteri / Plaka</th><th>Durum</th><th>Şube</th><th>Sorumlu</th><th>Kayıt Tarihi</th><th>İş Emri Değeri</th><th><span className="sr-only">İşlem</span></th></tr></thead>
          <tbody>{result.data.map(row => <tr key={row.id}>
            <td><strong>#{row.id}</strong><small>{row.type}</small></td>
            <td><strong>{row.plate}</strong><small>{row.customer || '-'}</small></td>
            <td><span className="rz-status">{row.status}</span></td><td>{row.branch}</td><td>{row.employee}</td>
            <td>{dateLabel(row.opened_at)}</td><td>{formattedPrice(row.net_value)}</td>
            <td><Link className="rz-row-action" to={`/service-detail/${row.id}`} aria-label={`Servis ${row.id} detayını aç`}><i className="fa fa-arrow-right" /></Link></td>
          </tr>)}</tbody>
        </table></div> : <div className="rz-empty">Bu filtrelere uyan servis bulunamadı.</div>}
      {!error && pagination && <div className="rz-register-pagination">
        <label>Sayfa başına satır <select aria-label="Sayfa başına satır" value={perPage} disabled={loading}
          onChange={event => { setPerPage(Number(event.target.value)); setPage(1); }}>
          <option value={10}>10</option><option value={20}>20</option><option value={50}>50</option>
        </select></label>
        <span>{pagination.total ? (currentPage - 1) * pagination.per_page + 1 : 0}–{Math.min(currentPage * pagination.per_page, pagination.total)} / {pagination.total} kayıt</span>
        <button type="button" aria-label="Önceki servis sayfası" disabled={loading || currentPage <= 1} onClick={() => setPage(currentPage - 1)}><i className="fa fa-angle-left" /></button>
        <span>{currentPage} / {pagination.last_page}</span>
        <button type="button" aria-label="Sonraki servis sayfası" disabled={loading || currentPage >= pagination.last_page} onClick={() => setPage(currentPage + 1)}><i className="fa fa-angle-right" /></button>
      </div>}
    </section>
  );
}
